<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">REKAPITULACIJA ULAZA</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>

      <div class="odabirDatuma" style="margin-right: 30px">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>

      <!-- OVO JE ODABIR SKLADIŠTA SIROVINA, ALI RADI CSS-a SE KLASA ZOVE ODABIR DATUMA -->
      <div class="odabirDatuma">
        <label [style]="{ 'margin-left': '30px' }">Odabir skladišta:</label>
        <dx-select-box
          displayExpr="sifrainaziv"
          [items]="skladistaSirovina"
          [showClearButton]="true"
          [searchEnabled]="true"
          (onValueChanged)="onChangeSkladisteSirovina($event)"
          width="400"
          [style]="{ 'margin-left': '30px' }"
        >
        </dx-select-box>
      </div>

      <div class="odabirDatuma">
        <dx-radio-group
          [items]="moguciOdabir"
          [value]="moguciOdabir[1]"
          layout="horizontal"
          (onValueChanged)="promjena($event)"
          [style]="{ 'margin-left': '30px' }"
        >
        </dx-radio-group>
      </div>

      <!-- OVO JE ZA PRAVLJENJE PDF-a, ALI RADI CSS-a SE KLASA ZOVE ODABIR DATUMA -->
      <div class="odabirDatuma">
        <dx-button
          *ngIf="stavkeUlazaSirovina.length > 0"
          (onClick)="pdfIzdatnicaUlazaSirovina()"
          [style]="{ 'margin-left': '30px' }"
          >Izradi PDF</dx-button
        >
      </div>
    </div>

    <div class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="stavkeUlazaSirovina"
        noDataText="{{ poruka }}"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0" style="padding-right: 30px">Dokumenti</h2>
            <p class="mt-0">Kliknite na dokument za prikaz detalja</p>
          </div>
        </div>

        <!-- <dxo-filter-row [visible]="true"></dxo-filter-row> -->
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[20, 30, 40]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="DV_NAZIV"
          caption="Vrsta dokumenta"
          [width]="160"
        ></dxi-column>

        <dxi-column
          dataField="ar_sifra"
          caption="Šifra"
          alignment="left"
          [width]="120"
        ></dxi-column>

        <dxi-column
          dataField="ar_naziv"
          caption="Naziv"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="ps_ulaz"
          caption="Količina"
          alignment="right"
          [width]="150">
          <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
        </dxi-column>

        <dxi-column
          dataField="jedinicamjere_JM_SIFRA"
          caption="Mjerna jedinica"
          alignment="center"
          [width]="120"
        ></dxi-column>

        <dxi-column
          dataField="ps_ulazc"
          caption="Cijena"
          alignment="right"
          [width]="150">
          <dxo-format type="fixedPoint" [precision]="3"></dxo-format>
        </dxi-column>

        <dxi-column
          dataField="ps_ulazvr"
          caption="Ukupno"
          alignment="right"
          [width]="150">
          <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
        </dxi-column>

        <dxo-summary>
          <dxi-total-item 
            column="ar_naziv" 
            summaryType="sum" 
            alignment="left" 
            displayFormat="Ukupno:">
          </dxi-total-item>
          <dxi-total-item
            column="ps_ulaz"
            summaryType="sum"
            alignment="right"
            displayFormat="{0}"
            [valueFormat]="{ type: 'fixedPoint', precision: 2 }">
          </dxi-total-item>
          <dxi-total-item
            column="ps_ulazvr"
            summaryType="sum"
            alignment="right"
            displayFormat="{0} €"
            [valueFormat]="{ type: 'fixedPoint', precision: 2 }">
          </dxi-total-item>
        </dxo-summary>

        <!-- <dxi-column alignment="left"></dxi-column> -->
      </dx-data-grid>
    </div>
  </div>
</div>
